import styled, { keyframes } from 'styled-components/macro'
import { mq } from 'styles/mq'

const COUNT = 12
const POS_RAD = 2 * Math.PI - (2 * Math.PI) / COUNT

const mainRotation = keyframes`
  from { transform: rotateX(-90deg) rotateZ(30deg); }
  to   { transform: rotateX(-90deg); }
`

const cardRotation = keyframes`
  from { transform: translate(-50%, -50%) rotateX(90deg) rotateY(-30deg) }
  to   { transform: translate(-50%, -50%) rotateX(90deg) }
`

export const CarouselSection = styled.div`
  width: 100%;
  overflow: hidden;
  max-height: 55rem;

  ${mq.smallOnly} {
    width: calc(100% + 2 * var(--container-spacing));
    margin-left: calc(-1 * var(--container-spacing));
    max-height: 70vw;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1200px) {
      max-height: 55rem;
    }

    ${mq.smallOnly} {
      max-height: none;
    }
  }
`

export const Container = styled.div`
  perspective: 115rem;
  transform: translateY(-27%) scale(0.8);
  width: 100%;
  max-width: 103rem;
  margin: 0 auto;

  ul {
    list-style: none;
    display: block;
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 50%;
    transform: rotateX(-90deg);
    animation: 1s ${mainRotation} ease-in-out forwards;
    transform-style: preserve-3d;
  }
  @media (max-width: 1200px) {
    transform: scale(0.8);
    width: 82rem;
  }
  ${mq.smallOnly} {
    perspective: 100vw;
    transform: translateY(-16%);
    width: 100%;
  }
`

export const Item = styled.li<{ index: number }>`
  position: absolute;
  top: ${props =>
    (100 + Math.round(100 * Math.sin(POS_RAD * props.index))) / 2}%;
  left: ${props =>
    (100 + Math.round(100 * Math.cos(POS_RAD * props.index))) / 2}%;
  transform-style: preserve-3d;

  img {
    display: block;
    width: 25rem;
    max-width: none;
    aspect-ratio: 1080 / 1350;
    object-fit: cover;
    transform: translate(-50%, -50%) rotateX(90deg);
    animation: 1s ${cardRotation} ease-in-out forwards;
    box-shadow: 14px 0 14px -14px rgba(0, 0, 0, 0.1),
      -14px 0 14px -14px rgba(0, 0, 0, 0.1);
    background-color: #030303;
  }

  ${mq.smallOnly} {
    img {
      width: 22vw;
    }
  }
`
